import { Tour, Customer } from './pages/Projects';

export const scrollToPage = (id: string, offset: number = 120) => {
  const element = document.getElementById(id);
  const bodyRect = document.body.getBoundingClientRect().top;
  const elementRect = element?.getBoundingClientRect().top;
  const elementPosition = (elementRect ?? 0) - bodyRect;
  const offsetPosition = elementPosition - offset;

  window.scrollTo({
    top: offsetPosition,
    behavior: 'smooth'
  });
};



export const getTourPath = (tour: Tour, customers: Customer[]): string | null => {
  const customer = customers.find((c) => c.id === tour.customerId);
  if (!customer || !tour.slug) return null;
  return `${customer.slug}/${tour.slug}`;
}